import React, { lazy } from 'react';
import { authPages, dashboardMenu, demoPages, othersMenu, publicPages } from '../menu';
import Establishment from '../pages/presentation/registers/establishment/establishment';
import Stores from '../pages/presentation/registers/stores/stores';
import Products from '../pages/presentation/pdv/product/produtos';
import PreRegister from '../pages/presentation/pdv/preRegister';
import PdvFeedbacks from '../pages/presentation/pdv/feedbacks';
import FiscalGroups from '../pages/presentation/pdv/fiscalGroups';
import Categories from '../pages/presentation/pdv/categories/categories';
import SubCategories from '../pages/presentation/pdv/subCategories/subCategories';
import Printers from '../pages/presentation/store/printers/printers';
import Complement from '../pages/presentation/pdv/complement/complement';
import Users from '../pages/presentation/registers/users/users';
import Clients from '../pages/presentation/registers/clients/clients';
import Beneficiaries from '../pages/presentation/registers/beneficiaries/beneficiaries';
import CategoryComplement from '../pages/presentation/pdv/categoryComplement/categoryComplement';
import Totens from '../pages/presentation/registers/totens/totens';
import Goals from '../pages/presentation/registers/goals/goals';
import Menus from '../pages/presentation/pdv/menus/menus';
import Stocks from '../pages/presentation/pdv/stocks/stocks';
import StoreSubscription from '../pages/presentation/subscription/store/StoreSubscription';
import EstablishmentSubscription from '../pages/presentation/subscription/establishment/EstablishmentSubscription';
import MatrizSubscription from '../pages/presentation/subscription/matriz/MatrizSubscription';
// import Reports from '../pages/presentation/reports/Reports';
// import Notifications from '../pages/presentation/notifications/Notifications';
import Profile from '../pages/presentation/profile/Profile';
import ContactUs from '../pages/presentation/contactUs/ContactUs';
import Settings from '../pages/presentation/settings/Settings';
// import Documentations from '../pages/presentation/documentations/Documentations';
import Cashier from '../pages/presentation/store/cashier';
import StoreComplements from '../pages/presentation/pdvLoja/complements';
import StoreCategories from '../pages/presentation/pdvLoja/categories';
import StoreProducts from '../pages/presentation/pdvLoja/products';
import StockComponents from '../pages/presentation/pdvLoja/stockComponents';
import StockProducts from '../pages/presentation/pdvLoja/stockProducts';
import StoreSettings from '../pages/presentation/store/settings';
import AccessPassword from '../pages/presentation/store/accessPasswrod';
import Suggestions from '../pages/presentation/pdv/suggestions';
import BoxOffice from '../pages/presentation/command/boxOffice';
import Defect from '../pages/presentation/store/defect';
import Request from '../pages/presentation/store/request'
import Discounts from '../pages/presentation/store/discounts/discounts';
import Reasons from '../pages/presentation/store/reasons';
import Cupons from '../pages/presentation/store/cupons';
import FaturamentoPorDia from '../pages/presentation/reports/faturamentoPorDia';
import Lojas from '../pages/presentation/delivery/store/lojas';
import ManagementDelivery from '../pages/presentation/delivery/manager';
import Feedbacks from '../pages/presentation/reports/feedbacks';
import UserHistory from '../pages/presentation/reports/userHistory/historyUser';
import ConsumptionsHistory from '../pages/presentation/reports/consumptions';
import ProductsPerHours from '../pages/presentation/reports/productsPerHour';
import UnissuedNotes from '../pages/presentation/fiscal/unissuedNotes';
import CategoriaComplemento from '../pages/presentation/pdvLoja/complementCategory';
import DeliveryUnissuedNotes from '../pages/presentation/fiscal/deliveryNotes';
import SubCategorie from '../pages/presentation/pdvLoja/subCategorie';
import Terminal from '../pages/presentation/registers/terminal/terminal';
import TerminalFiscal from '../pages/presentation/fiscal/terminalFiscal';
import Conversas from '../pages/presentation/delivery/conversation';
import Insumo from '../pages/presentation/pdv/insumo/insumo';
import EntradaInsumo from '../pages/presentation/pdvLoja/entradaInsumo';
import Cmv from '../pages/presentation/reports/cmv';
import SaidaInsumo from '../pages/presentation/pdvLoja/saidaInsumo';
import Monitor from '../pages/presentation/monitor';
import Monitores from '../pages/presentation/store/monitors';
import ItensNoInsume from '../pages/presentation/pdv/ProductNoInsumes/produtosSemInsumos';
import ItensComInsumos from '../pages/presentation/pdv/ProductsInsume/ProductsInsume';
import ManagementDeliveryV2 from '../pages/presentation/delivery/managerV2';
import Dre from '../pages/presentation/pdv/dre';
import GeralDre from '../pages/presentation/reports/geralDre';
import Integrations from '../pages/presentation/store/integrations';
import Everest from '../pages/presentation/integrations/everest';
import SignatureSubscription from '../pages/presentation/subscription/signature/SignatureSubscription';
import BillingValue from '../pages/presentation/billingValue/BillingValue';
import TicketsSubscription from '../pages/presentation/subscription/tickets/TicketsSubscription';
import Questions from '../pages/presentation/registers/questions/questions';
import Privacy from '../pages/presentation/privacy/Privacy';



const LANDING = {
  DASHBOARD: lazy(() => import('../pages/dashboard/DashboardPage')),
};
const AUTH = {
  LOGIN: lazy(() => import('../pages/presentation/auth/Login')),
  MONITOR_LOGIN: lazy(() => import('../pages/presentation/auth/Monitor_Login')),
  PAGE_404: lazy(() => import('../pages/presentation/auth/Page404')),
  ORDER_MONITOR: lazy(() => import('../pages/presentation/orderMonitor')),
  RESET_PASSWORD: lazy(() => import('../pages/presentation/reset-password/ResetPassword')),
};
const PAGE_LAYOUTS = {
  HEADER_SUBHEADER: lazy(() => import('../pages/presentation/page-layouts/HeaderAndSubheader')),
  HEADER: lazy(() => import('../pages/presentation/page-layouts/OnlyHeader')),
  SUBHEADER: lazy(() => import('../pages/presentation/page-layouts/OnlySubheader')),
  CONTENT: lazy(() => import('../pages/presentation/page-layouts/OnlyContent')),
  BLANK: lazy(() => import('../pages/presentation/page-layouts/Blank')),
  ASIDE: lazy(() => import('../pages/presentation/aside-types/DefaultAsidePage')),
  MINIMIZE_ASIDE: lazy(() => import('../pages/presentation/aside-types/MinimizeAsidePage')),
};
const EXTERNAL = {
  EVALUATION: lazy(() => import('../pages/presentation/evaluation')),
  CLIENT_REGISTER: lazy(() => import('../pages/presentation/clientRegister')),
};
const presentation = [
  /**
   * Auth
   */
  {
    path: othersMenu.resetPassword.path,
    element: <AUTH.RESET_PASSWORD />,
    exact: true,
  },
  {
    path: authPages.login.path,
    element: <AUTH.LOGIN />,
    exact: true,
  },
  {
    path: othersMenu.monitor_login.path,
    element: <AUTH.MONITOR_LOGIN />,
    exact: true,
  },
  {
    path: authPages.signUp.path,
    element: <AUTH.LOGIN isSignUp />,
    exact: true,
  },
  {
    path: authPages.page404.path,
    element: <AUTH.PAGE_404 />,
    exact: true,
  },

  {
    path: othersMenu.termsOfUse.path,
    element: <Privacy />,
    exact: true,
  },
  {
    path: '/privacidade',
    element: <Privacy />,
    exact: true,
  },
  {
    path: publicPages.evaluation.path,
    element: <EXTERNAL.EVALUATION />,
    exact: true,
  },
  {
    path: publicPages.clientRegister.path,
    element: <EXTERNAL.CLIENT_REGISTER />,
    exact: true,
  },

  /** ************************************************** */
  /**
   * Landing
   */
  {
    path: dashboardMenu.dashboard.path,
    element: <LANDING.DASHBOARD />,
    exact: true,
  },
  // {
  //   path: demoPages.reports.path,
  //   element: <Reports />,
  //   exact: true,
  // },
  // {
  //   path: demoPages.documentations.path,
  //   element: <Documentations />,
  //   exact: true,
  // },
  // {
  //   path: demoPages.notifications.path,
  //   element: <Notifications />,
  //   exact: true,
  // },
  // {
  //   path: demoPages.contactUs.path,
  //   element: <ContactUs />,
  //   exact: true,
  // },

  {
    path: demoPages.settings.path,
    element: <Settings />,
    exact: true,
  },

  {
    path: demoPages.billingValue.path,
    element: <BillingValue />,
    exact: true,
  },


  {
    path: demoPages.subscription.subMenu.store.path,
    element: <StoreSubscription />,
    exact: true,
  },

  {
    path: demoPages.subscription.subMenu.establishment.path,
    element: <EstablishmentSubscription />,
    exact: true,
  },

  {
    path: demoPages.subscription.subMenu.matriz.path,
    element: <MatrizSubscription />,
    exact: true,
  },

  {
    path: demoPages.subscription.subMenu.signature.path,
    element: <SignatureSubscription />,
    exact: true,
  },
  {
    path: demoPages.subscription.subMenu.tickets.path,
    element: <TicketsSubscription />,
    exact: true,
  },
  {
    path: othersMenu.orderMonitor.path,
    element: <AUTH.ORDER_MONITOR />,
    exact: false,
  },


  {
    path: authPages.profile.path,
    element: <Profile />,
    exact: true,
  },


  /** ************************************************** */

  /**
   * Page Layout Types
   */
  // {
  //   path: layoutMenu.blank.path,
  //   element: <PAGE_LAYOUTS.BLANK />,
  //   exact: true,
  // },
  // {
  //   path: layoutMenu.pageLayout.subMenu.headerAndSubheader.path,
  //   element: <PAGE_LAYOUTS.HEADER_SUBHEADER />,
  //   exact: true,
  // },
  // {
  //   path: layoutMenu.pageLayout.subMenu.onlyHeader.path,
  //   element: <PAGE_LAYOUTS.HEADER />,
  //   exact: true,
  // },
  // {
  //   path: layoutMenu.pageLayout.subMenu.onlySubheader.path,
  //   element: <PAGE_LAYOUTS.SUBHEADER />,
  //   exact: true,
  // },
  {
    path: demoPages.pageLayout.subMenu.establishment.path,
    element: <Establishment />,
    exact: true,
    min_level: demoPages.pageLayout.subMenu.establishment.min_level,
  },
  {
    path: demoPages.pageLayout.subMenu.stores.path,
    element: <Stores />,
    exact: true,
    min_level: demoPages.pageLayout.subMenu.stores.min_level,
  },
  {
    path: demoPages.pageLayout.subMenu.integrations.path,
    element: <Integrations />,
    exact: true,
    min_level: demoPages.pageLayout.subMenu.integrations.min_level,
  },
  {
    path: demoPages.pdvMenu.subMenu.categories.path,
    element: <Categories />,
    exact: true,
    min_level: demoPages.pdvMenu.subMenu.categories.min_level,
  },
  {
    path: demoPages.pdvMenu.subMenu.insumos.path,
    element: <Insumo />,
    exact: true,
    min_level: demoPages.pdvMenu.subMenu.insumos.min_level,
  },
  {
    path: demoPages.pdvMenu.subMenu.subCategories.path,
    element: <SubCategories />,
    exact: true,
    min_level: demoPages.pdvMenu.subMenu.subCategories.min_level,
  },
  {
    path: demoPages.store.subMenu.discounts.path,
    element: <Discounts />,
    exact: true,
    min_level: demoPages.store.subMenu.discounts.min_level,
  },
  {
    path: demoPages.store.subMenu.reasons.path,
    element: <Reasons />,
    exact: true,
    min_level: demoPages.store.subMenu.cashier.min_level,
  },
  {
    path: demoPages.store.subMenu.cupons.path,
    element: <Cupons />,
    exact: true,
    min_level: demoPages.store.subMenu.cashier.min_level,
  },
  {
    path: demoPages.store.subMenu.integrations.path,
    element: <Integrations />,
    exact: true,
    min_level: demoPages.store.subMenu.cashier.min_level,
  },
  {
    path: demoPages.pdvMenu.subMenu.complement.path,
    element: <Complement />,
    exact: true,
    min_level: demoPages.pdvMenu.subMenu.complement.min_level,
  },
  {
    path: demoPages.pdvMenu.subMenu.categoryComplement.path,
    element: <CategoryComplement />,
    exact: true,
    min_level: demoPages.pdvMenu.subMenu.categoryComplement.min_level,
  },
  {
    path: demoPages.pdvMenu.subMenu.product.path,
    element: <Products />,
    exact: true,
    min_level: demoPages.pdvMenu.subMenu.product.min_level,
  },
  {
    path: demoPages.pdvMenu.subMenu.preRegister.path,
    element: <PreRegister />,
    exact: true,
    min_level: demoPages.pdvMenu.subMenu.preRegister.min_level,
  },
  {
    path: demoPages.pdvMenu.subMenu.feedbacks.path,
    element: <PdvFeedbacks />,
    exact: true,
    min_level: demoPages.pdvMenu.subMenu.feedbacks.min_level,
  },
  {
    path: demoPages.pdvMenu.subMenu.fiscalGroups.path,
    element: <FiscalGroups />,
    exact: true,
    min_level: demoPages.pdvMenu.subMenu.fiscalGroups.min_level,
  },
  {
    path: demoPages.pdvMenu.subMenu.itensToInsume.path,
    element: <ItensComInsumos />,
    exact: true,
    min_level: demoPages.pdvMenu.subMenu.itensToInsume.min_level,
  },
  {
    path: demoPages.pdvMenu.subMenu.itensNoInsume.path,
    element: <ItensNoInsume />,
    exact: true,
    min_level: demoPages.pdvMenu.subMenu.itensNoInsume.min_level,
  },
  {
    path: demoPages.pdvMenu.subMenu.suggestion.path,
    element: <Suggestions />,
    exact: true,
    min_level: demoPages.pdvMenu.subMenu.suggestion.min_level,
  },
  {
    path: demoPages.pdvMenu.subMenu.dre.path,
    element: <Dre />,
    exact: true,
    min_level: demoPages.pdvMenu.subMenu.dre.min_level,
  },
  {
    path: demoPages.fiscal.subMenu.unissuedNotes.path,
    element: <UnissuedNotes />,
    exact: true,
    min_level: demoPages.fiscal.subMenu.unissuedNotes.min_level,
  },
  // {
  //   path: demoPages.fiscal.subMenu.terminal.path,
  //   element: <TerminalFiscal />,
  //   exact: true,
  //   min_level: demoPages.fiscal.subMenu.terminal.min_level,
  // },
  // {
  //   path: demoPages.fiscal.subMenu.deliveryNotes.path,
  //   element: <DeliveryUnissuedNotes />,
  //   exact: true,
  //   min_level: demoPages.fiscal.subMenu.deliveryNotes.min_level,
  // },
  {
    path: demoPages.pageLayout.subMenu.totens.path,
    element: <Totens />,
    exact: true,
    min_level: demoPages.pageLayout.subMenu.totens.min_level,
  },
  {
    path: demoPages.pageLayout.subMenu.goals.path,
    element: <Goals />,
    exact: true,
    min_level: demoPages.pageLayout.subMenu.goals.min_level,
  },
  {
    path: demoPages.pageLayout.subMenu.terminal.path,
    element: <Terminal />,
    exact: true,
    min_level: demoPages.pageLayout.subMenu.terminal.min_level,
  },
  {
    path: demoPages.pageLayout.subMenu.questions.path,
    element: <Questions />,
    exact: true,
    min_level: demoPages.pageLayout.subMenu.questions.min_level,
  },
  {
    path: demoPages.pageLayout.subMenu.users.path,
    element: <Users />,
    exact: true,
    min_level: demoPages.pageLayout.subMenu.users.min_level,
  },
  {
    path: demoPages.pageLayout.subMenu.clients.path,
    element: <Clients />,
    exact: true,
  },
  {
    path: demoPages.pageLayout.subMenu.beneficiaries.path,
    element: <Beneficiaries />,
    exact: true,
    min_level: demoPages.pageLayout.subMenu.beneficiaries.min_level,
  },
  {
    path: demoPages.pdvMenu.subMenu.menus.path,
    element: <Menus />,
    exact: true,
    min_level: demoPages.pdvMenu.subMenu.menus.min_level,
  },
  // {
  //   path: demoPages.pdvMenu.subMenu.stocks.path,
  //   element: <Stocks />,
  //   exact: true,
  // },
  {
    path: demoPages.pdvLoja.subMenu.complement.path,
    element: <StoreComplements />,
    exact: true,
  },
  {
    path: demoPages.pdvLoja.subMenu.complementCatergoria.path,
    element: <CategoriaComplemento />,
    exact: true,
  },
  {
    path: demoPages.pdvLoja.subMenu.category.path,
    element: <StoreCategories />,
    exact: true,
  },
  {
    path: demoPages.pdvLoja.subMenu.subCategoria.path,
    element: <SubCategorie />,
    exact: true,
  },
  {
    path: demoPages.pdvLoja.subMenu.product.path,
    element: <StoreProducts />,
    exact: true,
  },
  {
    path: demoPages.pdvLoja.subMenu.stockProducts.path,
    element: <StockProducts />,
    exact: true,
  },
  // {
  //   path: demoPages.pdvLoja.subMenu.cmv.path,
  //   element: <Cmv />,
  //   exact: true,
  // },
  // {
  //   path: demoPages.pdvLoja.subMenu.insumosLoja.path,
  //   element: <InsumosLoja />,
  //   exact: true,
  // },
  {
    path: demoPages.pdvLoja.subMenu.entradaInsumos.path,
    element: <EntradaInsumo />,
    exact: true,
  },

  {
    path: demoPages.pdvLoja.subMenu.saidaInsumos.path,
    element: <SaidaInsumo />,
    exact: true,
  },
  {
    path: demoPages.pdvLoja.subMenu.stockComponents.path,
    element: <StockComponents />,
    exact: true,
  },
  {
    path: demoPages.store.subMenu.cashier.path,
    element: <Cashier />,
    exact: true,
    min_level: demoPages.store.subMenu.cashier.min_level,
  },
  {
    path: demoPages.store.subMenu.defect.path,
    element: <Defect />,
    exact: true,
    min_level: demoPages.store.subMenu.defect.min_level,
  },
  {
    path: demoPages.store.subMenu.accessPassword.path,
    element: <AccessPassword />,
    exact: true,
  },
  {
    path: demoPages.store.subMenu.printers.path,
    element: <Printers />,
    exact: true,
    min_level: demoPages.store.subMenu.printers.min_level,
  },
  {
    path: demoPages.store.subMenu.monitors.path,
    element: <Monitores />,
    exact: true,
    min_level: demoPages.store.subMenu.monitors.min_level,
  },
  {
    path: demoPages.store.subMenu.settings.path,
    element: <StoreSettings />,
    exact: true,
    min_level: demoPages.store.subMenu.settings.min_level,
  },
  {
    path: demoPages.store.subMenu.request.path,
    element: <Request />,
    exact: true,
    min_level: demoPages.store.subMenu.request.min_level,
  },
  // {
  //   path: layoutMenu.pageLayout.subMenu.onlyContent.path,
  //   element: <PAGE_LAYOUTS.CONTENT />,
  //   exact: true,
  // },
  // {
  //   path: layoutMenu.asideTypes.subMenu.defaultAside.path,
  //   element: <PAGE_LAYOUTS.ASIDE />,
  //   exact: true,
  // },
  // {
  //   path: layoutMenu.asideTypes.subMenu.minimizeAside.path,
  //   element: <PAGE_LAYOUTS.MINIMIZE_ASIDE />,
  //   exact: true,
  // },

  {
    path: demoPages.command.subMenu.boxOffice.path,
    element: <BoxOffice />,
    exact: true,
    min_level: demoPages.command.subMenu.boxOffice.min_level,
  },
  {
    path: demoPages.reports.subMenu.cmv.path,
    element: <Cmv />,
    exact: true,
    min_level: demoPages.reports.subMenu.cmv.min_level,
  },

  {
    path: demoPages.reports.subMenu.faturamentoPorDia.path,
    element: <FaturamentoPorDia />,
    exact: true,
    min_level: demoPages.reports.subMenu.faturamentoPorDia.min_level,
  },
  {
    path: demoPages.reports.subMenu.productsPerHours.path,
    element: <ProductsPerHours />,
    exact: true,
    min_level: demoPages.reports.subMenu.productsPerHours.min_level,
  },
  {
    path: demoPages.reports.subMenu.consumptionsHistory.path,
    element: <ConsumptionsHistory />,
    exact: true,
    min_level: demoPages.reports.subMenu.consumptionsHistory.min_level,
  },
  {
    path: demoPages.reports.subMenu.userHistory.path,
    element: <UserHistory />,
    exact: true,
    min_level: demoPages.reports.subMenu.userHistory.min_level,
  },

  {
    path: demoPages.reports.subMenu.dre.path,
    element: <GeralDre />,
    exact: true,
    min_level: demoPages.reports.subMenu.dre.min_level,
  },

  {
    path: demoPages.reports.subMenu.feedbacks.path,
    element: <Feedbacks />,
    exact: true,
    min_level: demoPages.reports.subMenu.feedbacks.min_level,
  },
  {
    path: demoPages.integracoes.subMenu.everest.path,
    element: <Everest />,
    exact: true,
    min_level: demoPages.integracoes.min_level
  },
  {
    path: demoPages.delivery.subMenu.lojas.path,
    element: <Lojas />,
    exact: true,
    min_level: demoPages.delivery.subMenu.lojas.min_level
  },
  {
    path: demoPages.delivery.subMenu.menuV1.path,
    element: <ManagementDelivery />,
    exact: true,
    min_level: demoPages.delivery.subMenu.menuV1.min_level
  },
  {
    path: demoPages.delivery.subMenu.menuV2.path,
    element: <ManagementDeliveryV2 />,
    exact: true,
    min_level: demoPages.delivery.subMenu.menuV2.min_level
  },
  {
    path: demoPages.delivery.subMenu.conversas.path,
    element: <Conversas />,
    exact: true,
    min_level: demoPages.delivery.subMenu.conversas.min_level,
  },
];
const contents = [...presentation];

export default contents;
